import movements from './movements'
import receipts_cash from './receipts_cash'


export default [
    ...movements,
    ...receipts_cash,
]